import type { Capability } from "@redotech/account-common/capability";
import { useEnabledCapabilities } from "@redotech/redo-merchant-app-common/use-capability";
import { useReviewsWorkspaceAccess } from "@redotech/redo-merchant-review-app/use-reviews-workspace-access";

/**
 * Capabilities whose pages or automations live in the Marketing section. Return
 * tracking and HSA order emails are Marketing automations, so those count too.
 */
export const MARKETING_SECTION_CAPABILITIES = [
  "emailSms",
  "hsa",
  "orderTracking",
  "returns",
  "tnpl",
] as const satisfies readonly Capability[];

export function isMarketingSectionEnabled(
  enabled: ReadonlySet<Capability>,
  reviewsWorkspaceAvailable: boolean,
): boolean {
  return (
    reviewsWorkspaceAvailable ||
    MARKETING_SECTION_CAPABILITIES.some((capability) => enabled.has(capability))
  );
}

/** Whether the Marketing section has an active product to open, rather than its welcome page. */
export function useMarketingSectionEnabled(): boolean {
  const enabled = useEnabledCapabilities();
  const { workspaceAvailable } = useReviewsWorkspaceAccess();
  return isMarketingSectionEnabled(enabled, workspaceAvailable);
}
